import { useState, useEffect } from 'react';

/**
 * Hook personnalisé pour déterminer le statut d'abonnement de l'utilisateur.
 * Lit les données stockées localement après la connexion.
 * @returns {object} { plan, isTrial, isExpired, isPremium, trialDaysRemaining }
 */
export default function useSubscriptionStatus() {
    const [status, setStatus] = useState({
        plan: 'LOGGED_OUT',
        isTrial: false,
        isExpired: false,
        isPremium: false,
        isAdmin: false,
        trialDaysRemaining: null,
        maxAccounts: 2,
        canExport: false
    });

    useEffect(() => {
        const userString = localStorage.getItem('user');
        if (!userString) return;

        try {
            const user = JSON.parse(userString);
            const plan = user.plan || 'TRIAL';
            const isAdmin = user.role === 'Admin';
            const isPremium = plan === 'PREMIUM' || isAdmin;
            
            let isExpired = user.status === 'expired' || plan === 'TRIAL_EXPIRED';
            let days = null;

            if (user.expiryDate && !isAdmin) {
                const diff = new Date(user.expiryDate) - new Date();
                days = Math.ceil(diff / (1000 * 60 * 60 * 24));
                if (days <= 0) isExpired = true;
            }

            setStatus({
                plan,
                isAdmin,
                isPremium,
                isTrial: plan === 'TRIAL',
                isExpired: isAdmin ? false : isExpired,
                trialDaysRemaining: isAdmin ? null : days,
                maxAccounts: user.maxAccounts || 2,
                canExport: plan !== 'TRIAL' // Ta règle : pas d'export en Trial
            });
        } catch (e) { console.error(e); }
    }, []);

    return status;
}